import { render, staticRenderFns } from "./UpdateAPage.vue?vue&type=template&id=d5dce41c&"
import script from "./UpdateAPage.vue?vue&type=script&lang=js&"
export * from "./UpdateAPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports